<template>
  <div class="home-page">
    <div class="button-group">
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/qrCode')"
      >
        Scan QR
      </button>
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/manual')"
      >
        Enter Manually
      </button>
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/showtime')"
      >
        Showtimes
      </button>
      <button v-if="isMifClient" class="app-button" @click="testprintHandler()">
        Test Print
      </button>
      <button
        v-if="isMifClient"
        class="app-button"
        @click="$router.push('/reprint-manual')"
      >
        Re-Print
      </button>
      <!-- <button class="app-button logout" @click="onLogout">
        Logout
      </button> -->
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
export default {
  name: "Home",
  data() {
    return {
      EjsData: null,
    };
  },
  computed: {
    isQfxClient() {
      const clientName = window.localStorage.getItem("CLIENT_NAME");
      return clientName.toLowerCase() === "qfx";
    },

    isMifClient() {
      const clientName = window.localStorage.getItem("CLIENT_NAME");
      return clientName.toLowerCase() === "mif";
    },
  },
  methods: {
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();

      this.$cookie.delete("BRHSID");
      this.$router.push({ name: "login" });
    },
    testprintHandler(type) {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        let logged_in_cinema_id = window.localStorage.getItem("USERCINEINFO");
        try {
          if (this.$socket) {
            let testPrintObj = {
              cinema_id: logged_in_cinema_id,
              printType: 1,
            };
            let dataURL = `${BASEURL}/api/pos/testprint/${testPrintObj.cinema_id}/${testPrintObj.printType}`;
            this.$socket.emit("on_print_ticket", {
              baseurl: BASEURL,
              ttype: "dynamicURL",
              dataURL: dataURL,
            });
          }
        } catch (err) {
          console.log("Error:", err);
        }
      } else {
        this.printTest(type);
      }
    },
    printTest: function(type) {
      let loader = this.$loading.show();
      const cinema_id = window.localStorage.getItem("USERCINEINFO");
      let payload = {
        cinema_id: cinema_id,
        type: 1,
      };

      MasterService.TestPrint(payload)
        .then((response) => {
          // console.log("response :", response);

          if (response) {
            const { data } = response;

            this.EjsData = data;

            this.$nextTick(() => {
              const p = new Printd();
              if (this.$refs.onPrint && this.EjsData != null) {
                p.print(this.$refs.onPrint, []);
              }
            });
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>
<style scoped>
.home-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background: #f9fafb;
}

.title {
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.button-group {
  display: flex;
  flex-direction: column;
  /* gap: 15px; */
}

.app-button {
  width: 220px;
  padding: 14px 20px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 10px;
  margin-bottom: 15px;
  border: none;
  background: #b3a9e1;
  color: black;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.app-button.qfx {
  background: #0384b4 !important;
  color: #fff;
}

.app-button:hover {
  background: #76c2e1;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.app-button.logout {
  background: #ef4444;
}

.app-button.logout:hover {
  background: #dc2626;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue